// FILE: frontend/src/components/ui/GlassCard.tsx
import React from 'react';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  gradient?: boolean;
}

export const GlassCard: React.FC<GlassCardProps> = ({ 
  children, 
  className = '', 
  hover = true,
  gradient = false 
}) => {
  const baseClasses = "backdrop-blur-xl rounded-2xl border shadow-xl transition-all duration-300";
  const hoverClasses = hover ? "hover:shadow-2xl hover:scale-[1.02]" : "";
  const bgClasses = gradient 
    ? "bg-gradient-to-br from-white/90 to-slate-50/90 border-white/40" 
    : "bg-white/80 border-slate-200/50";

  return (
    <div className={`${baseClasses} ${hoverClasses} ${bgClasses} ${className}`}>
      {children}
    </div>
  );
};
